"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _actions = require("../actions");

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _urlSearchParams = _interopRequireDefault(require("@ungap/url-search-params"));

var _PasswordResetForm = _interopRequireDefault(require("../components/PasswordResetForm"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ResetPassword = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ResetPassword, _React$Component);

  function ResetPassword() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (newPassword) {
      var location = _this.props.location;
      var searchParams = new _urlSearchParams["default"](location.search);
      var newToken = searchParams.get('token') || '';
      var productId = searchParams.get('productId') || '';
      var env = process.env.REACT_APP_RM_ENV ? process.env.REACT_APP_RM_ENV : process.env.REACT_APP_ENV;
      var redirectUrl = (0, _helpers.getProductUrl)(productId, env);

      _this.props.resetPassword(newPassword, newToken).then(function (success) {
        if (success === true) {
          if (redirectUrl === '/') {
            _this.props.history.push('/');
          } else {
            window.location.href = redirectUrl;
          }
        }
      });
    });

    return _this;
  }

  var _proto = ResetPassword.prototype;

  _proto.render = function render() {
    var error = this.props.error;
    return /*#__PURE__*/React.createElement("div", {
      className: "page--multifaceted-bg-grey"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Container, {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout"
    }, /*#__PURE__*/React.createElement("h2", null, "Reset Password"), /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 10
    }, error && /*#__PURE__*/React.createElement(_semanticUiReact.Message, {
      warning: true,
      icon: false,
      content: error
    }), /*#__PURE__*/React.createElement(_PasswordResetForm["default"], {
      handleSubmit: this.handleSubmit
    })))))))));
  };

  return ResetPassword;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.user.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    resetPassword: _actions.resetPassword
  }, dispatch);
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResetPassword));

exports["default"] = _default;